// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiBaseUrl: "https://stageadmin.designleadership.academy/api/",
  apiEndpoint: "https://stageadmin.designleadership.academy/api/",
  imageurl:"https://stageadmin.designleadership.academy/"

  // apiBaseUrl: "https://dev3.snsepro.com/clients/grow/public/api/",
  // apiEndpoint: "https://dev3.snsepro.com/clients/grow/public/api/",
  // imageurl:"https://dev3.snsepro.com/clients/grow/public/"
};

// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
